export default {
    'ticket-selector-no_more_ticket': 'Nincs több elérhető jegy!',
};
